export default __webpack_public_path__ + "static/theporch-65134d4c12df3c3309790fc55d9b0d20.jpg";